function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/classCallCheck.js
// module id = 11
// module chunks = 0